const IconDefault = () => (
    <div></div>
);

export default IconDefault;
